import React from "react";

/* =========================================================
   src/header.jsx - sticky nav + mobile sheet
   ========================================================= */

function Header() {
  const y = useScrollY();
  const scrolled = y > 12;
  const [sheetOpen, setSheetOpen] = React.useState(false);

  React.useEffect(() => {
    document.body.style.overflow = sheetOpen ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [sheetOpen]);

  React.useEffect(() => {
    const onKey = (e) => { if (e.key === "Escape") setSheetOpen(false); };
    document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, []);

  const go = (id) => {
    setSheetOpen(false);
    setTimeout(() => smoothScrollTo(id), sheetOpen ? 280 : 0);
  };

  return (
    <>
      <header className={cx("nav", scrolled && "scrolled")}>
        <div className="wrap nav-row">
          <a
            href="#hero"
            className="brand"
            aria-label="Morse and Code home"
            onClick={(e) => { e.preventDefault(); go("hero"); }}
          >
            <span className="brand-mark">&amp;</span>
            <span className="brand-name">Morse<em>&amp;</em>Code</span>
          </a>
          <nav className="nav-links" aria-label="Primary">
            <button className="nav-link" onClick={() => go("services")}>Services</button>
            <button className="nav-link" onClick={() => go("values")}>Values</button>
            <button className="nav-link" onClick={() => go("contact")}>Contact</button>
            <a className="nav-link" href="https://morsecodesro.youtrack.cloud/" target="_blank" rel="noopener noreferrer">
              Helpdesk <Icon name="ArrowUpRight" size={14} />
            </a>
            <Button onClick={() => go("contact")} className="" style={{ marginLeft: 6 }}>
              Start a project
              <Icon name="ArrowRight" size={14} className="btn-arrow" />
            </Button>
          </nav>
          <button className="menu-btn" aria-label="Open menu" onClick={() => setSheetOpen(true)}>
            <Icon name="Menu" size={20} strokeWidth={2} />
          </button>
        </div>
      </header>

      <MobileSheet
        open={sheetOpen}
        onClose={() => setSheetOpen(false)}
        onNavigate={go}
      />
    </>
  );
}

function MobileSheet({ open, onClose, onNavigate }) {
  return (
    <div
      className={cx("sheet", open && "open")}
      aria-hidden={!open}
      onClick={(e) => { if (e.target.classList.contains("sheet")) onClose(); }}
    >
      <div className="sheet-panel" role="dialog" aria-label="Menu">
        <div className="sheet-head">
          <a
            href="#hero"
            className="brand"
            onClick={(e) => { e.preventDefault(); onNavigate("hero"); }}
          >
            <span className="brand-mark">&amp;</span>
            <span className="brand-name">Morse<em>&amp;</em>Code</span>
          </a>
          <button className="sheet-close" aria-label="Close menu" onClick={onClose}>
            <Icon name="X" size={18} />
          </button>
        </div>
        <div className="sheet-links">
          <button className="sheet-link" onClick={() => onNavigate("services")}>
            Services <Icon name="ArrowRight" size={18} />
          </button>
          <button className="sheet-link" onClick={() => onNavigate("values")}>
            Values <Icon name="ArrowRight" size={18} />
          </button>
          <button className="sheet-link" onClick={() => onNavigate("contact")}>
            Contact <Icon name="ArrowRight" size={18} />
          </button>
          <a
            className="sheet-link"
            href="https://morsecodesro.youtrack.cloud/"
            target="_blank" rel="noopener noreferrer"
            onClick={onClose}
          >
            Helpdesk <Icon name="ArrowUpRight" size={18} />
          </a>
        </div>
        <div className="sheet-foot">
          <a href="mailto:info@morsecode.cz">info@morsecode.cz</a>
          <span>Brno, CZ</span>
        </div>
      </div>
    </div>
  );
}

Object.assign(window, { Header });
